import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=72e7aa0a&scoped=true&"
import script from "./Curriculum.vue?vue&type=script&lang=js&"
export * from "./Curriculum.vue?vue&type=script&lang=js&"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=72e7aa0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e7aa0a",
  null
  
)

export default component.exports